"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _react2 = require("../hooks/react");

var _Button = _interopRequireDefault(require("../Button"));

var _SingleSelection = _interopRequireDefault(require("../context/SingleSelection"));

var _forms = require("../utils/forms");

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _excluded = ["dataQa", "value", "children"];

var styles = function styles(theme) {
  var _root;

  return {
    root: (_root = {
      boxShadow: 'none',
      minWidth: 'initial',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      borderRadius: 0
    }, (0, _defineProperty2["default"])(_root, theme.breakpoints.down('sm'), {
      marginLeft: 0,
      marginRight: 0,
      '&:not(:first-child):not(:last-child)': {
        borderTopWidth: 1,
        borderBottomWidth: 1
      },
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomWidth: 1
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderTopWidth: 1
      }
    }), (0, _defineProperty2["default"])(_root, theme.breakpoints.up('md'), {
      '&:not(:first-child):not(:last-child)': {
        borderLeftWidth: 1,
        borderRightWidth: 1
      },
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderRightWidth: 1
      },
      '&:last-child': {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderLeftWidth: 1
      }
    }), _root)
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var ToggleButton = function ToggleButton(_ref) {
  var dataQa = _ref.dataQa,
      value = _ref.value,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();

  var _useContext = (0, _react2.useContext)(_SingleSelection["default"]),
      selected = _useContext.selected,
      onSelect = _useContext.onSelect;

  var _useFormState = (0, _useFormState2["default"])(props),
      stateValue = _useFormState.value,
      name = _useFormState.name,
      helpers = _useFormState.helpers;

  var isValue = function isValue(val) {
    return val === value;
  };

  var isSelected = !onSelect ? isValue(stateValue) : isValue(selected);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: classes.root,
    dataQa: dataQa,
    variant: isSelected ? 'contained' : 'outlined',
    value: value,
    name: name,
    onClick: function onClick(event) {
      helpers && helpers.setValue(value);
      onSelect && onSelect(event, value);
    }
  }, children);
};

ToggleButton.propTypes = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** The value of the component. */
  value: _propTypes["default"].any,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
var _default = ToggleButton;
exports["default"] = _default;